import { render, staticRenderFns } from "./chatMonitor.vue?vue&type=template&id=cf72ff96&scoped=true&"
import script from "./chatMonitor.vue?vue&type=script&lang=js&"
export * from "./chatMonitor.vue?vue&type=script&lang=js&"
import style0 from "./chatMonitor.vue?vue&type=style&index=0&id=cf72ff96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf72ff96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf72ff96')) {
      api.createRecord('cf72ff96', component.options)
    } else {
      api.reload('cf72ff96', component.options)
    }
    module.hot.accept("./chatMonitor.vue?vue&type=template&id=cf72ff96&scoped=true&", function () {
      api.rerender('cf72ff96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/chatMonitor.vue"
export default component.exports